import React from 'react';
import styled from 'styled-components';
import { IconButton, SvgIcon, WysiwygEditor } from '../../../shared/components';

export const TableHeaders = styled.div`
  display: flex;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;
  padding-bottom: 1rem;
`;

export const DateColumn = styled(({ header, ...restProps }) => <div {...restProps} />)`
  width: 10rem;
  padding-top: ${({ header }) => (header ? 0 : '1.4rem')};
`;

export const FeedbackColumn = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 10rem);
`;

export const FeedbackRowWrapper = styled.div`
  display: flex;
  font-size: 1.4rem;
  border-top: 1px solid ${({ theme }) => theme.palette.grey['100']};
  cursor: pointer;
`;

export const Description = styled(({ student, expanded, ...restProps }) => <div {...restProps} />)`
  width: ${({ student, expanded }) =>
    student || expanded ? 'calc(100% - 7rem)' : 'calc(100% - 4rem)'};
  max-height: 100rem;
  transition: max-height 1s ease-in-out;
  overflow: hidden;

  & > *:first-child {
    margin-top: 0;
  }

  ${({ expanded }) =>
    !expanded &&
    `
  & > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  & > p:first-of-type {
    margin-top: 0;
  }

  & > p:not(:first-of-type) {
    display: none;
  }
  
  max-height: 10rem;
  `};
`;

export const IconsWrapper = styled.div`
  display: flex;
  padding-top: 1.4rem;
`;

export const DeleteButton = styled(IconButton)`
  margin-top: -0.4rem;
`;

export const ReadIcon = styled(SvgIcon)`
  margin-right: 0.5rem;
`;

export const RefinedTargetAudienceNotice = styled.div`
  padding-top: 1.4rem;
  color: ${({ theme }) => theme.palette.grey['700']};
`;

export const NewFeedbackLink = styled.div`
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.primary.main};
  margin-bottom: 1.4rem;
  padding-top: 1.4rem;
`;

export const FeedbackReadOnlyWysiwyg = styled(({ expanded, ...restProps }) => (
  <WysiwygEditor {...restProps} />
))`
  margin-bottom: 0;

  ${({ expanded }) =>
    !expanded &&
    `
    .fr-view > *:not(:first-child) {
      display: none;
    }
  
    .fr-view > *:first-child {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `}
`;
